import React, { Fragment, memo } from 'react';
import { classnames, isFunction } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { useRowGroup } from '../../hooks/table';
import { TableRowRender } from './TableRow';
export var TableRowGroup = memo(function (props) {
  var datasource = props.datasource,
      _props$expandedRowKey = props.expandedRowKeys,
      expandedRowKeys = _props$expandedRowKey === void 0 ? [] : _props$expandedRowKey,
      onExpandedRowChange = props.onExpandedRowChange,
      onRow = props.onRow,
      rowClassName = props.rowClassName,
      renderExpand = props.renderExpand,
      renderExpandHeight = props.renderExpandHeight;

  var _useRowGroup = useRowGroup({
    datasource: datasource,
    expandedRowKeys: expandedRowKeys,
    onExpandedRowChange: onExpandedRowChange
  }),
      rows = _useRowGroup.rows,
      expand = _useRowGroup.onExpand;

  var expandCls = usePrefixCls('table-row-expand');
  var rowList = rows.map(function (_ref, index) {
    var row = _ref.row,
        isLeaf = _ref.isLeaf,
        level = _ref.level,
        expanded = _ref.expanded,
        id = _ref.id,
        serials = _ref.serials;

    if (renderExpand && level !== 1) {
      return null;
    }

    var rowCls = isFunction(rowClassName) ? rowClassName(row, index) : rowClassName;

    var onExpand = function onExpand(expanded) {
      return expand(id, expanded);
    };

    var content = React.createElement(TableRowRender, Object.assign({
      className: rowCls
    }, onRow && onRow(row) || {}, {
      isLeaf: isLeaf,
      level: level,
      expanded: expanded,
      row: row,
      index: index,
      serials: serials,
      onExpand: onExpand,
      key: id
    }));

    if (expanded && renderExpand) {
      var expandContent = React.createElement(TableRowRender, Object.assign({
        className: classnames(expandCls, rowCls)
      }, onRow && onRow(row) || {}, {
        isLeaf: isLeaf,
        level: level,
        expanded: expanded,
        row: row,
        index: index,
        serials: serials,
        onExpand: onExpand,
        key: "".concat(id, "-expand"),
        rowHeight: renderExpandHeight,
        renderExpand: renderExpand
      }));
      return [content, expandContent];
    }

    return [content];
  }).flat(1);
  return React.createElement(Fragment, null, rowList);
});